import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import { useContext, useState } from "react";
import { useEffect } from "react";
import UserContext from "../../contexts/UserContext";
import UserSession from "../../components/sessions/session";
import UpdatePass from "../../components/sessions/updatepass";



export default function ViewSession() {
    // states
    const { user } = useContext(UserContext);
    const [page, setPage] = useState(0);


    const displayPages = () => {
        if (page === 0) {
            return <UserSession code={user.code} />;
        } else {
            return <UpdatePass code={user.code} />;
        }
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {

    }, []);



    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-2 font-weight-bold text_primary">Your profile</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Your informations</span>
                </button>
                <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>Update your password</span>
                </button>
            </div>
            {displayPages()}
        </div>
    )
}